import React from 'react';
import {Pages} from "../components/layout";
import {routes} from "../utils";
import {Button, useTitle} from 'fearless-common-ui';
import {ArrowRight} from "react-bootstrap-icons";

export default function CompleteAccountSuccess() {
    useTitle('Account completed!');
    return (
        <Pages.Centred width="xs" className="text-center">
            <h1 className="gradient-color mb-3">Account completed.</h1>
            <p>
                Start your adventure today.
            </p>
              <Button href={routes.login}>
                <ArrowRight /> Go to login
              </Button>
        </Pages.Centred>
    );
}
